module.exports = __webpack_public_path__ + "assets/seller.eb23c16211798fecc35b9322001193e2.png";


/*****************
 ** WEBPACK FOOTER
 ** ./img/seller.png
 ** module id = 224
 ** module chunks = 0
 **/